import { render, staticRenderFns } from "./RollRoom.vue?vue&type=template&id=3a513410&"
import script from "./RollRoom.vue?vue&type=script&lang=js&"
export * from "./RollRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports